import router from './index.js'

router.beforeEach((to,from,next) =>{
	if(!sessionStorage.getItem('login_token') && to.name != 'home'){
		next('/home')
	}else if(to.name == 'home'){
		next()
	}else{
		next()
	}
	
})

export default router